import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'
import { Button } from 'pcln-design-system'
import NavLink from '../NavLink'

const StyledNavLink = styled(NavLink)`
  padding: ${themeGet('space.3')};
  width: 100%;
`

const SignOutNavLink = ({ color, onClick }) => {
  const SIGN_OUT = 'Sign Out'
  return (
    <Button label={SIGN_OUT} size='large' variation='link' onClick={onClick}>
      <StyledNavLink iconName='Logout' color={color} label={SIGN_OUT} />
    </Button>
  )
}

SignOutNavLink.propTypes = {
  color: PropTypes.string,
  onClick: PropTypes.func,
}

export default SignOutNavLink
